import { render, staticRenderFns } from "./SamSectionHeader.vue?vue&type=template&id=045e43d8&scoped=true&shadow"
import script from "./SamSectionHeader.vue?vue&type=script&lang=js&shadow"
export * from "./SamSectionHeader.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamSectionHeader.vue?vue&type=style&index=0&id=045e43d8&prod&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "045e43d8",
  null
  ,true
)

export default component.exports